import MenuItemWithDialog, { IMenuItemWithDialogProps } from '../MenuList/MenuItemWithDialog';
import React from 'react';
import SceneDialogContent, { ISceneDialogContentProps } from './SceneDialogContent';
import Hamburger from '../../Icons/Hamburger';

export interface ISceneMenuItemProps
  extends Omit<IMenuItemWithDialogProps, 'title' | 'Icon' | 'children'>,
    ISceneDialogContentProps {}

const SceneMenuItem: React.FC<ISceneMenuItemProps> = ({
  onTarget,
  onNavigate,
  cardsReducer,
  ...props
}: ISceneMenuItemProps) => {
  return (
    <MenuItemWithDialog {...props} title="環境紀錄" Icon={Hamburger}>
      <SceneDialogContent onTarget={onTarget} onNavigate={onNavigate} cardsReducer={cardsReducer} />
    </MenuItemWithDialog>
  );
};
SceneMenuItem.displayName = 'SceneMenuItem';
export default SceneMenuItem;
